import {useQuery} from '@tanstack/react-query'
import useOcapiSite from '../../hooks/useOcapiSite'
import {useBazaarvoiceAPI} from '../context'

const useProductReviewOverview = (productId) => {
    const {bvEnabled} = useOcapiSite()
    const {getProductReviewOverview} = useBazaarvoiceAPI()
    const {
        data,
        error,
        isInitialLoading: loading
    } = useQuery({
        queryKey: ['product-review-overview', productId],
        queryFn: ({signal}) => getProductReviewOverview(productId, {signal}),
        enabled: Boolean(productId && bvEnabled)
    })

    return {
        data: data ?? null,
        error,
        loading
    }
}

export default useProductReviewOverview
